import { render, staticRenderFns } from "./single-info.vue?vue&type=template&id=a9057fa8&scoped=true&"
import script from "./single-info.vue?vue&type=script&lang=js&"
export * from "./single-info.vue?vue&type=script&lang=js&"
import style0 from "./single-info.vue?vue&type=style&index=0&id=a9057fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9057fa8",
  null
  
)

export default component.exports